import { AutoComplete, AutoCompleteCompleteMethodParams } from '../prime';
import React from 'react';
import { connect } from 'react-redux';
import { IDataStorage, Translate } from '../../core';
import { IControlProps, MapProps } from '.';
import styles from './index.module.scss';
import { Loader } from '..';

interface IProps extends IControlProps<any> {
  storage?: IDataStorage;
  /** listado de opciones */
  asyncOptions?: () => Promise<any[]>;
  /** listado de opciones */
  options?: () => any[];

  labelTemplate?: (row: any) => JSX.Element; 

  /** campo a mostrar */
  optionLabel?: string;
  /** campo unico */
  optionKey?: string;

  /** class para el Dropdown */
  inputClassName?: string;
  /** estilo para el Dropdown */
  inputStyle?: React.CSSProperties;
}

interface IState extends IControlProps<any> {
  storage?: IDataStorage;
  /** listado de opciones */
  asyncOptions?: () => Promise<any[]>;
  /** listado de opciones */
  options?: () => any[];
  /** campo a mostrar */
  optionLabel?: string;
  /** campo unico */
  optionKey?: string;

  /** Indica el mensaje de error si es que existe */
  validError?: string;
  /** class para el Dropdown */
  inputClassName?: string;
  /** estilo para el Dropdown */
  inputStyle?: React.CSSProperties;

  list?: {
    loaded: boolean;
    list: any[];
    filtro: any[];
  }
}

class Index extends React.Component<IProps, IState> {
  state: IState = {};

  componentDidMount = () => {
    Index.getDerivedStateFromProps(this.props, this.state);
    if (this.props?.form && this.props?.name) this.props.form.add(this, this.props.name, () => this.change(this.state.value));
    this.state.asyncOptions && this.state.asyncOptions()
      .then(data => {
        this.setState({ list: { loaded: true, list: data, filtro: [] } });
      });
  }
  static getDerivedStateFromProps = (p: IProps, s?: IState) : IState => {
    let res : IState = {};
    if (p?.storage !== s?.storage) res.storage = p.storage;
    if (p?.asyncOptions !== s?.asyncOptions) res.asyncOptions = p.asyncOptions;
    if (p?.options !== s?.options) {
      res.options = p.options;
      if (res.options) {
        const data = res.options() ?? [];
        res.list = { loaded: true, list: data, filtro: data };
      }
    }
    if (p?.optionLabel !== s?.optionLabel) res.optionLabel = p.optionLabel;
    if (p?.optionKey !== s?.optionKey) res.optionKey = p.optionKey;
    if (p?.inputClassName !== s?.inputClassName) res.inputClassName = p.inputClassName;
    if (p?.inputStyle !== s?.inputStyle) res.inputStyle = p.inputStyle;
    return MapProps(res, p, s);
  }

  
  search = (event: AutoCompleteCompleteMethodParams) => {
    const { list } = this.state;
    if (list) {
      let query = event.query;
      if (!query)
        list.filtro = list.list.slice(0);
      else
        list.filtro = list.list.filter(p => p[this.state.optionLabel ?? 'nombre'].toLowerCase().indexOf(query.toLowerCase()) >= 0).slice(0);
      this.setState({ list });
    }
  }

  render() {
    const { validError, list } = this.state;
    const t = Translate.get("components/forms/autodropdown", this.state.storage?.languaje);
    
    return (
      <Loader loading={!list?.loaded}>
        <div className={`form-group ${this.state.className ?? ''}`} style={this.state.style}>
          {this.state.title && <label className={(validError && styles.errortitle) ?? ''}>{this.state.title}</label>}
          <div className={`${styles.addons} p-inputgroup`}>
            {this.state.required && 
              <span className={`p-inputgroup-addon ${(validError && styles.erroraddon) ?? ''}`}>
                <i className="pi pi-exclamation-circle" />
              </span>
            }
            <AutoComplete 
              value={this.state.value} 
              placeholder={this.state.placeholder}
              disabled={this.state.disabled}
              suggestions={this.state.list?.filtro ?? []} 
              completeMethod={this.search}
              field={this.state.optionLabel}
              dropdown
              forceSelection
              itemTemplate={row => !!row && 
                <div style={{ color: !!row["bajafecha"] ? 'var(--danger)' : 'var(--color)' }}>
                  {this.props.labelTemplate ? this.props.labelTemplate(row) : <>{row[this.state.optionLabel ?? 'nombre']}</>}
                  {!!row["bajafecha"] ? ` (${t("Item.Eliminado")})` : ''}
                </div>
              }
              //itemTemplate={e => !!e && <div style={{ color: !!e["bajafecha"] ? 'var(--danger)' : 'var(--color)' }}>{e[this.state.optionLabel ?? 'nombre']}{!!e["bajafecha"] ? ` (${t("Item.Eliminado")})` : ''}</div>}
              //valueTemplate={e => !!e && <div style={{ color: !!e["bajafecha"] ? 'var(--danger)' : 'var(--color)' }}>{e[this.state.optionLabel ?? 'nombre']}{!!e["bajafecha"] ? ` (${t("Item.Eliminado")})` : ''}</div>}

              onChange={(e:any) => !this.state.disabled && this.change(e.value)}
              tooltip={validError}
              tooltipOptions={{ position: 'bottom' }}
              className={`w-100 ${styles.ctrl} ${this.state.inputClassName ?? ''} ${validError && 'p-error'} ${(!!this.state.value && !!this.state.value["bajafecha"]) && styles["item-eliminado"]}`}
              style={this.state.inputStyle}
            />
          </div>
          {validError && <span className={styles.errordesc}>{validError}</span>}
        </div>
      </Loader>
    );
  }
  
  change = (value?: any) : string | undefined => {
    const { onChange, validate, isValid } = this.props;

    let error = this.validate(value);
    if (validate) error = validate(value);
    if (isValid) isValid(!error, error);
    
    this.setState({ validError: error });

    if (onChange) onChange(value, error);

    return error;
  }

  private validate = (value?: string) : string | undefined => {
    const { required } = this.state;

    if (required && !value) return 'campo requerido';

    return undefined;
  }
}

export default connect((s:any) => ({ storage:s.main }))(Index);
